import categories from "./es/categories.json";
import error from "./es/error.json";
import items from "./es/items.json";
import lang from "./es/lang.json";
import layout from "./es/layout.json";
import live from "./es/live.json";
import loki from "./es/loki.json";
import media from "./es/media.json";
import online from "./es/online.json";
import organization from "./es/organization.json";
import payouts from "./es/payouts.json";
import preferences from "./es/preferences.json";
import sales from "./es/sales.json";
import search from "./es/search.json";
import sidenav from "./es/sidenav.json";
import user from "./es/user.json";

const countries = require("i18n-iso-countries");
countries.registerLocale(require("i18n-iso-countries/langs/es.json"));

export default {
    ...categories,
    ...countries.getNames("es"),
    ...error,
    ...items,
    ...lang,
    ...layout,
    ...live,
    ...loki,
    ...media,
    ...online,
    ...organization,
    ...payouts,
    ...preferences,
    ...sales,
    ...search,
    ...sidenav,
    ...user
};
